export const BAR = 'BAR'
export const CUSTOMER = 'CUSTOMER'
export const SALON = 'SALON'


export const ORDER_ORIGINS = [BAR, CUSTOMER, SALON]
